/* eslint-disable no-unused-expressions */
/* eslint-disable react/forbid-prop-types */
import React from "react";
import Select from "react-select";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { selectStyles } from "./styles";
import * as communicationActions from "../../redux/actions/communicationActions";

const mapDispatchToProps = {
  ...communicationActions,
};

const mapStateToProps = (state) => {
  const { workflows } = state;

  return {
    stateWorkflow: workflows,
  };
};

const validate = (values) => {
  const errors = {};

  if (!values.replyToName) {
    errors.replyToName = "Required!";
  } else if (values.replyToName > 15) {
    errors.replyToName = "Must be 15 characters or less";
  }

  if (!values.subject) {
    errors.subject = "Required!";
  }

  if (!values.replyToEmail) {
    errors.replyToEmail = "Required!";
  } else if (
    !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      values.replyToEmail,
    )
  ) {
    errors.replyToEmail = "Invalid email address";
  }

  return errors;
};

const Form = ({
  delayedPatch,
  event,
  stateWorkflow,
  canSaveWorkflow,
  smartFieldOptions,
  handlePatchWorkflowStep,
}) => {
  const eventWorkFlow = stateWorkflow[event];

  const workflow = eventWorkFlow.blocks.find(
    (b) => b.id === stateWorkflow.activeWorkflowId,
  );

  const [formErrors, setFormErrors] = React.useState({});
  const [subjectCursorPosition, setSubjectCursorPosition] = React.useState(0);
  const [selected, setSelected] = React.useState(null);

  const runValidation = React.useCallback(() => {
    const errors = validate(workflow);

    setFormErrors(errors);
  }, [workflow]);

  const onSubjectBlur = React.useCallback(
    (e) => {
      setSubjectCursorPosition(e.target.selectionStart);
      runValidation();
      canSaveWorkflow(event, workflow.id);
    },
    [setSubjectCursorPosition, canSaveWorkflow, event, workflow, runValidation],
  );

  const handleSubjectChange = React.useCallback(
    (change) => {
      handlePatchWorkflowStep(workflow.id, {
        subject: change.target.value,
      });

      runValidation();
      canSaveWorkflow(event, workflow.id);
    },
    [handlePatchWorkflowStep, canSaveWorkflow, event, workflow, runValidation],
  );

  const handleSelectChange = React.useCallback(
    (change) => {
      const newSubject =
        workflow.subject.slice(0, subjectCursorPosition) +
        change.value +
        workflow.subject.slice(subjectCursorPosition);

      handlePatchWorkflowStep(workflow.id, {
        subject: newSubject,
      });

      runValidation();

      canSaveWorkflow(event, workflow.id);

      setSelected(change.value);
    },

    [
      handlePatchWorkflowStep,
      canSaveWorkflow,
      event,
      runValidation,
      workflow.id,
      subjectCursorPosition,
      workflow.subject,
    ],
  );

  const mounted = React.useRef(false);

  React.useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  return (
    <div>
      <div className="pp_trigger_edit_panel_block">
        <span className="pp_trigger_edit_panel_block_title">Reply to Name</span>
        <input
          type="text"
          name="replyToName"
          className={`pp_trigger_edit_panel_block_input ${
            formErrors.replyToName || stateWorkflow.errors.replyToName
              ? "pp_trigger_edit_panel_block_input_error"
              : ""
          }`}
          onChange={(e) => {
            delayedPatch(stateWorkflow.activeWorkflowId, {
              replyToName: e.target.value,
            });
            runValidation();
          }}
          onBlur={runValidation}
          value={workflow.replyToName}
        />
        {(stateWorkflow.errors.replyToName || formErrors.replyToName) && (
          <p className="pp_trigger_error">
            {formErrors.replyToName || stateWorkflow.errors.replyToName}
          </p>
        )}
      </div>
      <div className="pp_trigger_edit_panel_block">
        <span className="pp_trigger_edit_panel_block_title">
          Reply to Email
        </span>
        <input
          type="email"
          name="replyToEmail"
          className={`pp_trigger_edit_panel_block_input ${
            formErrors.replyToEmail || stateWorkflow.errors.replyToEmail
              ? "pp_trigger_edit_panel_block_input_error"
              : ""
          }`}
          onChange={(e) => {
            delayedPatch(stateWorkflow.activeWorkflowId, {
              replyToEmail: e.target.value,
            });

            runValidation();
          }}
          onBlur={runValidation}
          value={workflow.replyToEmail}
        />
        {(stateWorkflow.errors.replyToEmail || formErrors.replyToEmail) && (
          <p className="pp_trigger_error">
            {formErrors.replyToEmail || stateWorkflow.errors.replyToEmail}
          </p>
        )}
      </div>
      <div className="pp_trigger_edit_panel_block">
        <span className="pp_trigger_edit_panel_block_title">Subject</span>
        <div
          className={`pp_trigger_edit_panel_subject_wrapper ${
            (formErrors.subject || stateWorkflow.errors.subject) &&
            !workflow.subject
              ? "pp_trigger_edit_panel_block_input_error"
              : ""
          }`}
        >
          <div
            className="pp_trigger_edit_panel_subject_wrapper_part"
            style={{ width: "100%" }}
          >
            <div
              className="pp_trigger_edit_panel_smart_field"
              style={{ width: "30%" }}
            >
              <Select
                className="pp_trigger_edit_panel_smart_field_select"
                placeholder="Smart Fields"
                key={`pp_subject_smart_select__${selected}`}
                value={selected || ""}
                onChange={handleSelectChange}
                options={smartFieldOptions}
                styles={selectStyles}
              />
            </div>
            <div className="pp_trigger_edit_panel_emoji_wrapper" />
          </div>
          <div className="pp_trigger_edit_panel_subject_wrapper_part">
            <input
              type="text"
              onChange={(e) => {
                handleSubjectChange(e);
              }}
              className="pp_trigger_edit_panel_block_input"
              value={workflow.subject}
              onBlur={onSubjectBlur}
            />
          </div>
        </div>
        {(formErrors.subject || stateWorkflow.errors.subject) &&
          !workflow.subject && (
            <p className="pp_trigger_error">
              {formErrors.subject || stateWorkflow.errors.subject}
            </p>
          )}
      </div>
    </div>
  );
};

Form.propTypes = {
  event: PropTypes.string.isRequired,
  stateWorkflow: PropTypes.object.isRequired,
  smartFieldOptions: PropTypes.array.isRequired,
  delayedPatch: PropTypes.func.isRequired,
  canSaveWorkflow: PropTypes.func.isRequired,
  handlePatchWorkflowStep: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);
